import * as React from "react";

interface Props extends React.PropsWithChildren {
  className?: string;
}
export const FormItemValue: React.FC<Props> = ({ children, className = "" }) => {
  return <div className={`cpln-ant-form-item-value ${className}`}>{children}</div>;
};
